import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import {alterarTipoPrecoItinerarioEmLote} from '../../actions/itinerario/alterarTipoPrecoItinerarioEmLote'
import {renderFieldSelect, requiredSelect} from '../../util/inputs';
import {showSuccessMsg} from '../../util/messagesUtil';
import DiasSemanaSelector from './DiasSemanaSelector';


registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


export class ModalAlteracaoTipoPrecoItinerarioEmLote extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = {dataInicio: null, dataFim: null, diasSelecionados: []}
    }

    montarParametroItinerario(values) {
        return {
            dataInicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            empresaId: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            diasSelecionados: this.state.diasSelecionados ? this.state.diasSelecionados: [],
            tipoPreco: values.tipoPreco.value
        }
    }

    fecharModal() {
        $('#ModalAlteracaoTipoPrecoItinerarioEmLote')
            .modal('hide');
        $('#ModalAlteracaoTipoPrecoItinerarioEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);
        this.props.alterarTipoPrecoItinerarioEmLote(parametros)
            .then(() => {
                showSuccessMsg('Operação realizada com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios();
            })
    }


    limparFormulario() {
        this.props.reset('formularioAlteracaoTipoPrecoPorPeriodo');
        this.setState({dataInicio: null, dataFim: null});
    }


    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }


    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioAlteracaoTipoPrecoPorPeriodo',
                'valorAjuste', '');
            this.props.changeFieldValue('formularioAlteracaoTipoPrecoPorPeriodo',
                'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioAlteracaoTipoPrecoPorPeriodo',
            'exibirAjuste', evento.target.value);
    }

    exibirComboTipoPreco(name, label) {
        return <Field name={name}
                      options={this.props.tiposPreco.map(elemento => ({
                          descricao: elemento.descricaoTipoPreco,
                          nome: elemento.tipoPreco
                      }))}
                      component={renderFieldSelect}
                      label={label}
                      menuPortalTarget={document.body}
                      placeholder='Selecione a categoria' validate={requiredSelect}/>
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='ModalAlteracaoTipoPrecoItinerarioEmLote' role='dialog'
                 aria-labelledby='ModalAlteracaoTipoPrecoItinerarioEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content vx-modal-content">
                        <div className="vx-modal-header">
                            <div className="vx-modal-header-left">
                                <i className="material-icons">label</i>
                                <span className="vx-modal-title">Alterar categoria em lote</span>
                            </div>
                            <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="vx-modal-body">
                            <form id="form-alterar-tipo-preco-em-lote" onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <span style={{color: 'red', fontWeight: 'bold'}}>*Esta alteração não se aplicará nos itinerários de categorias mistas</span>
                                    </div>
                                     <div className="col-12 col-sm-4 col-md-4 mt-2">
                                          <label>Opera em quais dias da semana?</label>
                                          <DiasSemanaSelector
                                            diasSelecionados={this.state.diasSelecionados}
                                            onChange={(novosDias) => this.setState({ diasSelecionados: novosDias })}
                                          />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data de início</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data fim</label>
                                        {this.exibirCalendario()}
                                    </div>
                                    <div className="col-12 col-sm-9 col-md-9">
                                        <div className="form-row mt-2">
                                            <div className="col-12 col-sm-9 col-md-9">
                                                <Field name='tipoPreco'
                                                       options={this.props.tiposPreco.map(elemento => ({
                                                           descricao: elemento.descricaoTipoPreco,
                                                           nome: elemento.tipoPreco
                                                       }))}
                                                       component={renderFieldSelect}
                                                       label='Categoria do itinerário'
                                                       menuPortalTarget={document.body}
                                                       placeholder='Selecione a categoria' validate={requiredSelect}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div className="vx-modal-footer">
                            <button type="submit" form="form-alterar-tipo-preco-em-lote"
                                disabled={invalid || submitting || !this.state.dataInicio || !this.state.dataFim}
                                className="vx-btn-primary">
                                <i className="material-icons" style={{ fontSize: '16px' }}>save</i> Salvar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        exibirAjuste: formValueSelector('formularioAlteracaoTipoPrecoPorPeriodo')(state, 'exibirAjuste'),
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada,
        tiposPreco: state.tiposPreco

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        alterarTipoPrecoItinerarioEmLote,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlteracaoTipoPrecoPorPeriodo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoTipoPrecoItinerarioEmLote));
